var $16ee6a80c7459c88$exports = {};
/** All dropdowns on the page */ const $16ee6a80c7459c88$var$dropdowns = document.querySelectorAll(".navbar .links .dropdown");
/**
 * Hides all dropdowns except one
 * @param exception the dropdown element
 */ function $16ee6a80c7459c88$var$hideAllExcept(exception) {
    $16ee6a80c7459c88$var$dropdowns.forEach((dropdown)=>{
        if (dropdown == exception) return;
        dropdown.classList.toggle("show", false);
    });
}
$16ee6a80c7459c88$var$dropdowns.forEach((dropdown)=>{
    dropdown.addEventListener("click", ()=>{
        // hide all dropdowns when one is clicked
        $16ee6a80c7459c88$var$hideAllExcept(dropdown);
        // only show the clicked dropdown
        dropdown.classList.toggle("show");
    });
    // allow dropdowns to be hovered, and have it separate from clicked visibility
    dropdown.addEventListener("mouseenter", ()=>{
        dropdown.classList.toggle("hover", true);
    });
    // remove hover visibility after a timeout to prevent annoyances
    dropdown.addEventListener("mouseleave", ()=>{
        setTimeout(()=>dropdown.classList.toggle("hover", false), 150);
    });
});


//# sourceMappingURL=4f608304.js.map
